import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { IconX } from '@tabler/icons-react'

const TitleList = forwardRef(
  function TitleList(props, ref) {
    const [title, setTitle] = useState("");
    const [sectionTitle, setSectionTitle] = useState("");
    const [sectionSubTitle, setSectionSubTitle] = useState("");
    const [navbarTitle, setNavbarTitle] = useState("");

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setSectionTitle(props.data.sectionTitle);
        setSectionSubTitle(props.data.sectionSubTitle);
        setNavbarTitle(props.data.navbarTitle);
      }
    }, [props.data])


    const validate = () => {
      const errors = {};
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        title: title,
        sectionTitle:sectionTitle,
        sectionSubTitle:sectionSubTitle,
        navbarTitle:navbarTitle,
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
<>


<div className="card mt-3">
      <div className="card-body">
        <h5>{title}</h5>
        <div className="row">
          <div className="col-md-6 mt-2">
            <label className="form-label">Section Title</label>
            <input
              type="text"
              className={`form-control`}
              placeholder="Set Section Title"
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
            />
          </div>
          <div className="col-md-6 mt-2">
            <label className="form-label">Section Sub-Title</label>
            <input
              type="text"
              className={`form-control`}
              placeholder="Set Section Sub-Title"
              value={sectionSubTitle}
              onChange={(e) => setSectionSubTitle(e.target.value)}
            />
          </div>
          <div className="col-md-6 mt-2">
            <label className="form-label">Navbar Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Set Section Navbar-Title"
              value={navbarTitle}
              onChange={(e) => setNavbarTitle(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
      </>
    )
  });

export default TitleList;
